// jQueryはcdnで読み込み
// @types/jqueryを読み込んでいるのでエラーは出ないようにしている
// <reference path='./pages/db_quest.ts' />
// import * as quest from './pages/db_quest';

module quest {
    declare var createjs: any;

    let stage;
    let stageHeight;
    let stageWidth;
    let $boxes = $('.quest_boxes');
    let w = $boxes.width();
    let h = $boxes.height();
    let instances = [];
    let canvasElement;
    let result;
    let instanceNum = 20;

    export function initialize(id, resultClass):void {
        canvasElement=(<HTMLInputElement>document.getElementById(id));
        result = resultClass;

        $(window).on("resize",function(){
            w = $(window).width();
            h = $(window).height();
            canvasElement.width = w;
            canvasElement.height = h;
        });

        stage = new createjs.Stage(canvasElement);
    }

    export function start() {
        let intervalID;

        let $boxes = $('.quest_boxes');
        canvasElement.width = $boxes.width();
        canvasElement.height = $boxes.height();


        createjs.Ticker.framerate = createjs.Ticker.RAF;
        createjs.Ticker.timingMode = createjs.Ticker.RAF
        createjs.Ticker.addEventListener("tick", animate);

        stageHeight = canvasElement.height;
        stageWidth = canvasElement.width;

        if(result === 'gold') {
            instanceNum = 300;
            // intervalID = setInterval(function(){
                addInstance();
            // }, getRandom(200, 1000));

            // 30病後に消える
            // setTimeout(()=>{
            //     clearInterval(intervalID);
            // }, 8000)
        } else if(result === 'silver') {
            instanceNum = 100;
            addInstance();
        } else {
            addInstance();
        }

    }

    function addInstance() {
        let w_max = w-50
        let h_max = h-50
        let x = getRandom(50, w_max);
        let y = getRandom(50, h_max);

        for(let i=instanceNum; i > -1; i--){
            // createInstance(x, y, 40);
            createInstance(w/2+40, h/2-140, 40);
        }
        stage.update();
    }

    function createInstance(x, y, halfSpeed) {
        let speed = getRandom(-halfSpeed, halfSpeed);
        let angle = getRandom(0, Math.PI * 2);
        let instance = createShape(2, 10);
        let scale = getRandom(0.2, 0.5);
        let rotateDir = Math.random() >= 0.5 ? 1 : -1;
        let rotateRate = getRandom(0, 10);

        instance.x = x;
        instance.y = y + 200;
        instance.velocityX = Math.cos(angle) * speed;
        instance.velocityY = Math.sin(angle) * speed;
        instance.velocityAlpha = getRandom(-0.07, -0.01);
        instance.rotateDir = rotateDir;
        instance.rotateRate = rotateRate;

        stage.addChild(instance);
        // instances.push(instance);
    }

    function animate() {
        let count = stage.getNumChildren() - 1;
        // let count = instances.length;
        for (let i = count; i > -1; i--) {
            let child = stage.getChildAt(i);
            // let child = instances[i];
            let newY = child.y + child.velocityY;
            let newAlpha = child.alpha + child.velocityAlpha;
            if (newAlpha <= 0 || newY > stageHeight) {
                stage.removeChildAt(i);
                // stage.removeChild(child);
            } else {
                child.x += child.velocityX;
                child.y = newY;
                child.alpha = newAlpha;
                child.velocityX *= 0.98;
                child.velocityY += 1.5;
                child.rotation += child.rotateRate * child.rotateDir;
            }
        }

        stage.update();
    }
    function createShape(min, max) {
        let landNum = 50;
        let img_name = Math.floor( Math.random () * 6) + 1;
        let faceLand = Math.floor( Math.random () * landNum) + 1;
        if (faceLand == 1) {
            img_name = 6;
        }
        let instance = new createjs.Bitmap("/images/db_station/quest/coins/coin_"+img_name+".png");

        let scale = getRandom(0.09, 0.25);
        let deg =  getRandom(-20, 20);

        instance.regX = 100;
        instance.regY = 100;

        instance.scaleX = scale;
        instance.scaleY = scale;

        instance.rotation = deg;

        return instance;
    }
    function getRandom(min, max) {
        let randomNumber = Math.random() * (max - min) + min;
        return randomNumber;
    }
}



$(function() {
    let $btns = $('.js-quest-btn');
    let $btnWrapper = $('.js-quest-btns');
    let $boxes = $('.quest_box');
    let clicked = false;
    let sequence = 1;
    let maxSequence = 6

    let getPath = (filename) => {
        return '/images/db_station/quest/'
                + filename
                + '_'
                + sequence
                + '.png';
    }

    let $sound = $('.js-sound');
    let sound;

    let initBoxes = ()=> {
        $btns.on('click', function(){
            if(clicked === true) {
                return false;
            }

            let $target = $(this.getAttribute('href'));
            if($target.length === 0) {
                return false;
            }

            if($sound.length > 0) {
                sound = $sound.get(0) as HTMLMediaElement;
                sound.play();
            }

            clicked = true;
            let resultNum = $("#result_area").data('result')
            let result = "copper";
            if(resultNum == 1) {
                result = "gold";
            } else if (resultNum == 2) {
                result = "silver";
            }

            let seq1FadeOut = ()=> {
                $boxes.not($target).animate({
                    opacity: 0
                }, {
                    duration: 400,
                    complete: function(){
                        $(this).height(0);
                    }
                });


                if($target.attr('id') === 'quest-box-1') {
                    $target.css('transform', 'translateX(210px)')
                } else if($target.attr('id') === 'quest-box-3') {
                    $target.css('transform', 'translateX(-210px)')
                }

                setTimeout(function(){
                    openBox();
                }, 600);

                $btnWrapper.animate({
                    height: 0
                })
            }

            let openBox = ()=> {
                let fileName = $target.data('image');
                let path = getPath(fileName);

                let timerId = setInterval(function(){
                    sequence++;

                    $target.addClass('sequence-' + sequence);
                    // $target.css('background', "blue");
                    if(sequence >= maxSequence) {
                        clearInterval(timerId);
                        showResult();
                    }
                }, 100);
            }

            let showResult = ()=> {
                let $result = $('#result_area');
                $result.css({
                    display: 'block'
                });

                $target.delay(400).animate({
                    'margin-top': $result.height()+40
                }, {
                    duration: 800,
                    complete: ()=> {
                        showPoint();
                    }
                });

                $result.css('opacity', 1);
            }


            let showPoint = ()=> {
                $('.quest-point').delay(200).slideDown({
                    complete: ()=> {
                        quest.initialize('myCanvas', result);
                        quest.start();
                        $target.addClass('win');
                    }
                });
            }

            seq1FadeOut();
            

            return false;
        })
    }

    let init = ()=> {
        if($btns.length === 0) {
            return;
        }

        initBoxes();
        // quest.initialize('myCanvas2');
    }

    init();
});


